import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { apmCaptureError } from '../../apm'
import { type LOCALE } from '../../i18n'

import { gkAirAccessorGetUnderscoreLocale } from './gkAirAccessorGetUnderscoreLocale'

export const gkAirAccessorGetLocalizedProductPharmaForm = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string => {
  const productUrl =
    product[`pharma_form_${gkAirAccessorGetUnderscoreLocale(locale)}`]

  if (!productUrl) {
    apmCaptureError(
      new Error(
        `GK_AIR: product pharma form not found for "${product.UID}" for ${locale}`,
      ),
    )

    return ''
  }

  return productUrl
}
